import axios from 'axios'

const apiUrl = '/api'
const endpoints = {
    projects: `${window.location.origin}${apiUrl}/projects.json`,
    project: `${window.location.origin}${apiUrl}/projects/`,
}

const API = axios.create({
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json'
    }
})

function requestCreator() {
    let call
    return (url, options) => {
        if (call) {
            // call.cancel('too many requests')
        }
        call = axios.CancelToken.source()
        return API.request(url, {
            ...options,
            cancelToken: call.token
        })
    }
}

export const cancellableRequest = requestCreator()


function getFilteredProjects(data) {
    return cancellableRequest(endpoints.projects, {
        method: 'GET',
        params: data,
        responseType: 'json',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
}

function getProjectBySlug(slug) {
    return cancellableRequest(endpoints.project + slug + '.json', {
        method: 'GET',
        responseType: 'json',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    })
}

export default {
    getFilteredProjects,
    getProjectBySlug
}
